/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable view-models/no-unused-meta */
/* eslint-disable react/prop-types */
// TODO: remove view-models/no-unused-meta and eslint-disable react/prop-types rule when this issue https://github.com/asbjornh/view-models/issues/18 is resolved
import React from 'react';
import PropTypes from 'prop-types';
import LinkBase from 'components/models/link-base';
import cn from 'classnames';

const Link = ({
  className,
  openInNewTab = false,
  url,
  text,
  tabindex,
  onFocus = () => {},
  onBlur = () => {},
}) => (
  <a
    href={url}
    className={cn('link', {
      [className]: className,
    })}
    target={openInNewTab ? '_blank' : null}
    rel={openInNewTab ? 'nofollow noopener noreferrer' : null}
    tabIndex={tabindex}
    onFocus={onFocus}
    onBlur={onBlur}
  >
    {text}
  </a>
);

Link.viewModelMeta = {
  className: 'ignore',
  tabindex: 'ignore',
  onFocus: 'ignore',
  onBlur: 'ignore',
};

Link.propTypes = Object.assign({}, LinkBase.propTypes, {
  className: PropTypes.string,
  tabindex: PropTypes.number,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
});

export default Link;
